import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
// @mui
import { Grid, Divider, Card, Link, Typography, Stack, Chip, Box, Button } from '@mui/material';

// ----------------------------------------------------------------------

ShopCourseCard.propTypes = {
  course: PropTypes.object,
};

export default function ShopCourseCard({ course }) {
  const { name, level, price, info, hours, duration, link } = course;
  const ll = course.lesson_length;

  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/teacher/products', { state: course });
  };

  return (
    <Card
      sx={{
        p: 2,
        borderRadius: 2,
        boxShadow: 3,
        transition: 'transform 0.18s ease, box-shadow 0.18s ease',
        '&:hover': {
          transform: 'translateY(-6px)',
          boxShadow: 6,
        },
      }}
    >
      <Stack spacing={2} sx={{ p: 2 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Link color="text.primary" underline="hover" onClick={handleClick} component="button">
              <Typography variant="h6" sx={{ fontWeight: 700, fontSize: 22 }} noWrap>
                {name}
              </Typography>
            </Link>
            <Chip label={level ? 'Classic' : 'Base'} size="small" color="secondary" />
          </Box>

          {/* price moved to its own row below */}
          <Box />
        </Stack>

        <Typography sx={{ color: 'text.secondary', fontSize: 15 }}>{info}</Typography>

        {link ? (
          <Box>
            <Button component="a" href={link} target="_blank" rel="noreferrer" size="small">
              Презентація
            </Button>
          </Box>
        ) : null}

        {/* Price row */}
        <Box>
          <Chip label={`${price} грн.`} color="primary" sx={{ fontWeight: 700, fontSize: 16, py: '4px' }} />
        </Box>

        <Divider />

        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Box sx={{ mb: 1 }}>
              <Typography variant="caption" color="text.secondary">
                Тривалість
              </Typography>
              <Typography variant="body2">{duration} місяців</Typography>
            </Box>

            <Box sx={{ mb: 1 }}>
              <Typography variant="caption" color="text.secondary">
                Містить
              </Typography>
              <Typography variant="body2">5 Edmaps</Typography>
            </Box>

            <Box sx={{ mb: 1 }}>
              <Typography variant="caption" color="text.secondary">
                1 заняття
              </Typography>
              <Typography variant="body2">{ll} год.</Typography>
            </Box>
          </Grid>

          <Grid item xs={6}>
            <Box sx={{ mb: 1 }}>
              <Typography variant="caption" color="text.secondary">
                На місяць
              </Typography>
              <Typography variant="body2">{hours} годин</Typography>
            </Box>

            <Box sx={{ mb: 1 }}>
              <Typography variant="caption" color="text.secondary">
                Ціна/міс.
              </Typography>
              <Typography variant="body2">{price} грн.</Typography>
            </Box>

            <Box sx={{ mb: 1 }}>
              <Typography variant="caption" color="text.secondary">
                Включене
              </Typography>
              <Typography variant="body2">+включене</Typography>
            </Box>
          </Grid>
        </Grid>
      </Stack>
    </Card>
  );
}
